import Mustache from 'mustache';

export type Settings = {
  ajaxUrl: string;
};

export default class SiteSearch {
  dom: {
    root: HTMLElement;
    loadMoreForm: HTMLFormElement;
    resultsContainer: HTMLElement;
  };
  id: string;
  template: string;
  settings: Settings;
  processingClickEvent: string | boolean = false;


  constructor(element, options?: Partial<Settings>) {
    const defaultSettings = {
      ajaxUrl: '/stage-ajax/siteSearch/',
    };

    this.settings = Object.assign({}, defaultSettings, options);

    const form = element.querySelector('[data-search-load-more-form]');
    const id = form?.getAttribute('data-search-load-more-form');

    this.id = id;

    this.dom = {
      root: element,
      loadMoreForm: form,
      resultsContainer: element.querySelector(`[data-search-results-container=${id}]`),
    };

    this.template = document.getElementById(`template-search-item-${id}`)?.textContent || '';

    // All neccessary elements found, init
    if(Object.keys(this.dom).every(key => this.dom[key]) && this.id && this.template) {
      console.log('site-search.init()');
      this.attachEventListeners();
    }
  }

  attachEventListeners() {
    this.dom.root.addEventListener('click', this.onClickDelegated.bind(this));
    this.dom.loadMoreForm.addEventListener('submit', this.onLoadMore.bind(this));
  }

  onClickDelegated(event: Event) {
    const eventTarget = event.target as HTMLElement;
    const clickTarget: HTMLElement | null = eventTarget.classList.contains('search-result') ? eventTarget : eventTarget.closest('.search-result');

    if (clickTarget && clickTarget.dataset?.searchItem && clickTarget.dataset?.searchItemUrl === clickTarget.getAttribute('href')) {
      event.preventDefault();

      this.sendClickEvent({
        url: clickTarget.getAttribute('href'),
        id: clickTarget.dataset?.searchItem,
        position: clickTarget.dataset?.searchItemPosition,
        term: clickTarget.dataset?.searchItemTerm,
      });

      return false;
    }
  }

  onLoadMore(event: Event) {
    event.preventDefault();
    this.setLoading(true);

    const form = event.target as HTMLFormElement;
    const submitBtn = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const formData = new FormData(form);
    const formProps = Object.fromEntries(formData) as unknown as Record<string, string>;

    fetch(`${this.settings.ajaxUrl}?` + new URLSearchParams(formProps).toString())
      .then(response => response.json())
      .then((response) => {
        if (response.page) {
          const page = form.querySelector('[name="page"]');
          if (page) {
            page.setAttribute('value', response.page + 1);
          }
        }

        if (response.hits) {
          const lastChild = this.dom.resultsContainer.lastElementChild;
          lastChild?.insertAdjacentHTML('afterend', response.hits.map((item: any) => Mustache.render(this.template, item)).join(''));
        }

        if (response.total_hits <= response.page * response.limit) {
          if(submitBtn) {
            submitBtn.remove();
          }
        }
      })
      .catch((err) => {
        console.error(`Search err error: ${err.message}`);
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  setLoading(state: boolean) {
    this.dom.root.classList.toggle('loading', state);
  }


  sendClickEvent(data: any) {
    if (this.processingClickEvent) {
      return;
    }

    this.processingClickEvent = data.id;

    let locationChanging = false;
    const loadTargetPath = () => {
      if (data.url && !locationChanging) {
        locationChanging = true;
        window.location = data.url;
      }
    };

    try {
      fetch(`${this.settings.ajaxUrl}?stage-language=${document.documentElement.lang}&context=reportClick`, {
        method: 'POST',
        body: JSON.stringify({
          id: data.id,
          position: parseInt(data.position),
          term: data.term,
        }),
      }).then((res) => {
        loadTargetPath();
      }).catch((err) => {
        loadTargetPath();
      });

      return true;
    } catch (err) {
      if (err instanceof Error && err.name !== 'AbortError') {
        console.log(err);
      }
    }

    // Navigate to new url after small delay, even if ajax request has not completed
    setTimeout(loadTargetPath, 500);
  }
};
